
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/our-coffee",
      function () {
        return require("private-next-pages/[region]/[lang]/our-coffee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/our-coffee"])
      });
    }
  